import React, { Component, Fragment } from "react";
import DataGrid, {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";

import { formatDate } from "../../helpers/globalfunctions.js";
import { axiosPost } from "../../apis/useAxios.js";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { LoadPanel } from "devextreme-react/load-panel";
import { DateFormat } from "../../helpers/fixcodes.js";
import moment from "moment";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { data } from "jquery";
const position = { of: "#historydiv" };
const DATE_RANGE_PRESETS = [
  { label: "Today", getRange: () => [moment(), moment()] },
  {
    label: "Yesterday",
    getRange: () => [moment().subtract(1, "day"), moment().subtract(1, "day")],
  },
  {
    label: "This Week",
    getRange: () => [moment().startOf("week"), moment().endOf("week")],
  },
  {
    label: "Last Week",
    getRange: () => [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "This Month",
    getRange: () => [moment().startOf("month"), moment().endOf("month")],
  },
  {
    label: "Last Month",
    getRange: () => [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
];
export class RatingComponent extends Component {
  static displayName = RatingComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      datasource: null,
      transportDatasource: [],
      hotelList: [],
      transportList: [],
      transportRatingId: 2,
      hotelRatingId: 1,
      searchFromDate: new Date(),
      searchToDate: new Date(),
      loadPanelVisible: false,
    };
    this.refDateRangePicker = React.createRef();
  }
  applyDateRangePreset = (preset) => {
    try {
      const [start, end] = preset.getRange();
      this.setState({
        searchFromDate: start.toDate(),
        searchToDate: end.toDate(),
      });
      if (this.refDateRangePicker.current) {
        this.refDateRangePicker.current.setOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  isDateRangePresetActive = (preset) => {
    const [start, end] = preset.getRange();
    return (
      this.state.searchFromDate &&
      this.state.searchToDate &&
      start.isSame(this.state.searchFromDate, "day") &&
      end.isSame(this.state.searchToDate, "day")
    );
  };
  renderDateRangeCalendarContainer = ({ className, children }) => {
    return (
      <CalendarContainer className={className}>
        <div className="dc-daterange-shell">
          <div className="dc-daterange-presets">
            {DATE_RANGE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`dc-preset-btn${
                  this.isDateRangePresetActive(preset) ? " active" : ""
                }`}
                onClick={() => this.applyDateRangePreset(preset)}
              >
                {preset.label}
              </button>
            ))}
          </div>
          <div className="dc-daterange-months">{children}</div>
        </div>
      </CalendarContainer>
    );
  };
  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: this.GetRating.bind(this),
      },
    });
  };
  async componentDidMount() {
    document.querySelector("#lblPageTitle").innerHTML =
      `Crew Rating Comment and Reply`;
    await this.GetHotelsRating();
    await this.GetTransportRating();
  }

  GetHotelsRating = async (e) => {
    this.setState({ loadPanelVisible: true });
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let filterFromDatetime = moment(this.state.searchFromDate).startOf("day");
      let filterToDatetime = moment(
        this.state.searchToDate ?? this.state.searchFromDate,
      ).endOf("day");
      const response = await axiosPost("Rating/GetRating", {
        AirlineCode: airlineCode,
        RatingType: parseInt(this.state.hotelRatingId),
        FromDate: moment(filterFromDatetime).format(`YYYY-MM-DD HH:mm:ss`),
        ToDate: moment(filterToDatetime).format(`YYYY-MM-DD HH:mm:ss`),
        UserMasterId: 1,
      });
      this.setState({
        datasource: response?.payload ?? [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".GetHotelsRating function",
        err,
      );

      this.setState({ loadPanelVisible: false });
    }
  };
  GetTransportRating = async () => {
    this.setState({ loadPanelVisible: true });
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");

      let request = {};
      request.AirlineCode = airlineCode;
      request.RatingType = parseInt(this.state.transportRatingId);
      request.FromDate = formatDate(this.state.searchFromDate, "MM/dd/yyyy");
      request.ToDate = formatDate(
        this.state.searchToDate ?? this.state.searchFromDate,
        "MM/dd/yyyy",
      );
      request.UserMasterId = 1;

      const response = await axiosPost("Rating/GetRating", request);

      this.setState({
        transportDatasource: response?.payload ?? [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".GetTransportRating function",
        err,
      );

      this.setState({ loadPanelVisible: false });
    }
  };
  handleSearchRating = (e) => {
    e.preventDefault();
    this.GetHotelsRating();
  };

  render() {
    const drawRating = (count) => {
      if (count === 1) {
        return (
          <div>
            <i className="fa fa-light fa-star"></i>
          </div>
        );
      } else if (count === 2) {
        return (
          <div>
            <i className="fa fa-light fa-star"></i>
            <i class="fa fa-light fa-star"></i>
          </div>
        );
      } else if (count === 3) {
        return (
          <div>
            <i className="fa fa-light fa-star"></i>
            <i class="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
          </div>
        );
      } else if (count === 4) {
        return (
          <div>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
          </div>
        );
      } else if (count === 5) {
        return (
          <div>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
            <i className="fa fa-light fa-star"></i>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <style>{`
          /* ── Rating — theme matching sidebar #8E6448 ── */
          .ca-filter-card {
            background: #ffffff;
            border: none;
            border-radius: 10px 10px 0 0;
            box-shadow: 0 2px 12px rgba(142,100,72,0.12);
            padding: 0 !important;
            overflow: hidden;
          }
          .ca-filter-body { padding: 0.75rem 1rem 0.6rem; }
          .ca-filter-body label {
            font-size: 0.73rem;
            font-weight: 600;
            color: #8E6448;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 0.25rem;
          }
          
          /* tabs */
          .ca-grid-wrap .nav-tabs .nav-link {
            color: #8E6448;
            font-weight: 600;
            font-size: 0.8rem;
          }
          .ca-grid-wrap .nav-tabs .nav-link.active {
            color: #8E6448;
            border-bottom: 2px solid #8E6448;
            background: transparent;
          }
          /* DataGrid header row */
          .ca-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .ca-grid-wrap .dx-datagrid-filter-row td {
            background-color: #f5ede4 !important;
          }
          .ca-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .ca-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.6rem !important;
          }
          .dc-daterange-field {
            flex: 0 0 176px;
            min-width: 176px;
          }
          .dc-daterange-wrapper {
            display: block;
            width: 100%;
          }
          .dc-daterange-input {
            display: block;
            width: 100%;
            border: 1px solid #e3d5c6;
            border-radius: 6px;
            background: #fffdfb;
            padding: 5px 9px;
            min-height: 31px;
            font-size: 0.8rem;
            color: #333;
            box-sizing: border-box;
            outline: none;
            transition: border-color 0.15s ease;
          }
          .dc-daterange-input:hover {
            border-color: #d9c3aa;
          }
          .dc-daterange-input:focus {
            border-color: #f4691e;
            box-shadow: none;
          }
          .react-datepicker-popper {
            z-index: 1050;
          }
          .react-datepicker__day--in-range,
          .react-datepicker__day--in-selecting-range,
          .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--keyboard-selected {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--range-start,
          .react-datepicker__day--range-end,
          .react-datepicker__day--selecting-range-start,
          .react-datepicker__day--selecting-range-end,
          .react-datepicker__day--selected {
            background-color: #f4691e;
            color: #ffffff;
          }
          .react-datepicker__header {
            background-color: #fdf7f2;
            border-bottom: 1px solid #e8d5c4;
          }
          .dc-daterange-shell {
            display: flex;
            align-items: stretch;
          }
          .dc-daterange-presets {
            display: flex;
            flex-direction: column;
            gap: 2px;
            padding: 8px 6px;
            background: #fdf7f2;
            border-right: 1px solid #e8d5c4;
            min-width: 112px;
          }
          .dc-preset-btn {
            border: none;
            background: transparent;
            text-align: left;
            padding: 6px 10px;
            font-size: 0.78rem;
            font-weight: 600;
            color: #6b4a2b;
            border-radius: 5px;
            cursor: pointer;
            white-space: nowrap;
            transition: background 0.15s ease, color 0.15s ease;
          }
          .dc-preset-btn:hover {
            background: #f5e7d8;
          }
          .dc-preset-btn.active {
            background: #f4691e;
            color: #ffffff;
          }
          .dc-daterange-months {
            position: relative;
          }
        `}</style>

        <div className="filter-box mb-0">
          <div className="card ca-filter-card p-0 m-0">
            <div className="ca-filter-body">
              <div className="row align-items-end">
                <div className="col-lg-2   col-md-4 dc-daterange-field">
                  <div className="form-group mb-0">
                    <label>From - To Date</label>
                    <ReactDatePicker
                      ref={this.refDateRangePicker}
                      calendarContainer={this.renderDateRangeCalendarContainer}
                      selectsRange={true}
                      startDate={
                        this.state.searchFromDate
                          ? moment(this.state.searchFromDate).toDate()
                          : null
                      }
                      endDate={
                        this.state.searchToDate
                          ? moment(this.state.searchToDate).toDate()
                          : null
                      }
                      onChange={([start, end]) => {
                        this.setState({
                          searchFromDate: start,
                          searchToDate: end,
                        });
                      }}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/dd/yyyy - MM/dd/yyyy"
                      onChangeRaw={(e) => e.preventDefault()}
                      className="dc-daterange-input"
                      wrapperClassName="dc-daterange-wrapper"
                      monthsShown={2}
                      showPopperArrow={false}
                      portalId="dc-daterange-portal"
                    />
                  </div>
                </div>
                <div className="col-lg-1 col-md-2">
                  <div className="form-group mb-0">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm"
                      onClick={this.handleSearchRating}
                    >
                      <i className="fas fa-search" /> Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card ca-grid-wrap mt-0"
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        >
          <div className="card-body">
            <div>
              <ul
                className="nav nav-tabs mt-1 ml-2"
                id="custom-tabs-tab"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="custom-tabs-home-tab"
                    data-toggle="pill"
                    href="#custom-tabs-home"
                    role="tab"
                    aria-controls="custom-tabs-home"
                    aria-selected="true"
                    value={this.state.hotelRatingId}
                  >
                    Hotel
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="custom-tabs-profile-tab"
                    data-toggle="pill"
                    href="#custom-tabs-profile"
                    role="tab"
                    aria-controls="custom-tabs-profile"
                    aria-selected="false"
                    value={this.state.transportRatingId}
                    onClick={(e) => this.GetTransportRating()}
                  >
                    Transport{" "}
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="tab-content tab-bordered"
              id="custom-tabs-tabContent"
            >
              <div
                className="tab-pane fade active show"
                id="custom-tabs-home"
                role="tabpanel"
                aria-labelledby="custom-tabs-home-tab"
                onClick={(e) => this.GetHotelsRating(e)}
              >
                <DataGrid
                  dataSource={this.state.datasource}
                  selection={{ mode: "single" }}
                  columnsAutoWidth={false}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  columnResizingMode="widget"
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#fff0e6";
                      e.cellElement.style.color = "#000000";
                    }
                  }}
                  onToolbarPreparing={this.handleToolbarPreparing}
                >
                  <Column
                    dataField="airlineCode"
                    caption="Airline"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Airport"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="employeeNumber"
                    caption="Employee #"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="crewName"
                    caption="Crew Name"
                    width={220}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="designation"
                    caption="Position"
                    width={120}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="dateOfRating"
                    caption="Rating Date"
                    width={140}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                    // calculateCellValue={(row) =>
                    //   formatDate(row.dateOfRating, "dd-MMM-yyyy ")
                    // }
                  />
                  <Column
                    dataField="hotelName"
                    caption="Hotel"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="service"
                    caption="Facility"
                    width={150}
                    dataType="string"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => drawRating(data.data.service)}
                  />
                  <Column
                    dataField=""
                    caption="Amenities"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField=""
                    caption="Check In "
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  {/* <Column dataField="food" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Food" />
                                    <Column dataField="cleanliness" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Cleanliness" />
                                    <Column dataField="quality" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Room Quality" />
                                    <Column dataField="Bed" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Sleep Quality" />
                                    <Column dataField="comments" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Comments" />
                                    <Column dataField="reservationDate" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Reservation Date" />
                                    <Column dataField="ratingType" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Rating Type" />
                                    <Column dataField="replyMsg" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Reply Msg" />
                                    <Column dataField="replyDatetime" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Reply Datetime" /> */}
                  <SortByGroupSummaryInfo summaryItem="count" />
                  <GroupPanel visible={false} />
                  <HeaderFilter visible={true} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Grouping autoExpandAll={true} />
                  <Paging defaultPageSize={20} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="HotelRating"
                  />
                </DataGrid>
              </div>

              <div
                tabname={this.state.rowTabName}
                className="tab-pane fade"
                id="custom-tabs-profile"
                role="tabpanel"
                aria-labelledby="custom-tabs-profile-tab"
                onClick={(e) => this.GetTransportRating()}
              >
                <DataGrid
                  dataSource={this.state.transportDatasource}
                  selection={{ mode: "single" }}
                  columnsAutoWidth={false}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  columnResizingMode="widget"
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#8E6448";
                      e.cellElement.style.color = "#ffffff";
                    }
                  }}
                  onToolbarPreparing={this.handleToolbarPreparing}
                >
                  <Column
                    dataField="airlineCode"
                    caption="Airline"
                    width={100}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Airport"
                    width={100}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="employeeNumber"
                    caption="Employee #"
                    width={100}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="crewName"
                    caption="Crew Name"
                    width={220}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="designation"
                    caption="Position"
                    width={120}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="DateOfRating"
                    caption="Rating Date"
                    width={140}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                    // calculateCellValue={(row) =>
                    //   formatDate(row.dateOfRating, "dd-MMM-yyyy")
                    // }
                  />
                  {/* <Column dataField="" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="From " /> */}
                  <Column
                    dataField="transporterName"
                    caption="Transporter"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="service"
                    caption="Service"
                    width={210}
                    dataType="string"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => drawRating(data.data.service)}
                  />
                  <Column
                    dataField="cleanliness"
                    caption="Cleanliness"
                    width={210}
                    dataType="string"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => drawRating(data.data.cleanliness)}
                  />
                  <Column
                    dataField="punctuality"
                    caption="Punctuality"
                    width={210}
                    dataType="string"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => drawRating(data.data.punctuality)}
                  />
                  <Column
                    dataField="quality"
                    caption="Quality"
                    width={210}
                    dataType="string"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => drawRating(data.data.quality)}
                  />
                  {/* <Column dataField="comments" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Comments" />
                                    <Column dataField="reservationDate" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Reservation Date" />
                                    <Column dataField="dateOfRating" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption="Rating Date Time" />
                                    <Column dataField="replyMsg" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Reply Msg" />
                                    <Column dataField="replyDatetime" width={150} allowSearch={true} allowFiltering={false} allowSorting={true} caption=" Reply Datetime" /> */}
                  <GroupPanel visible={false} />
                  <HeaderFilter visible={true} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Grouping autoExpandAll={true} />
                  <Paging defaultPageSize={10} />
                  <Pager
                    displayMode="full"
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="TransportRating"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={position}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </Fragment>
    );
  }
}
